var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"LmJpaWthcDAgewogIGJvcmRlci1yYWRpdXM6IDhweDsKICBib3gtc2hhZG93OiAwcHggNHB4IDhweCByZ2JhKDAsIDAsIDAsIDAuMjUpOwogIGJhY2tncm91bmQ6IHdoaXRlOwogIG92ZXJmbG93OiBoaWRkZW47Cn0KLmJpaWthcDEgewogIG1hcmdpbjogMTBweDsKfQouYmlpa2FwMiB7CiAgYm9yZGVyLXJhZGl1czogOHB4OwogIGJveC1zaGFkb3c6IDBweCA0cHggOHB4IHJnYmEoMCwgMCwgMCwgMC4yNSk7CiAgYmFja2dyb3VuZDogd2hpdGU7CiAgb3ZlcmZsb3c6IGhpZGRlbjsKfQ==\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};